import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetFeaturesResponse } from "@/types/features";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getFeatures = async (
  query: string | null = null
): Promise<GetFeaturesResponse> => {
  try {
    const { data }: { data: GetFeaturesResponse } = await axiosInstance.get(
      `/v1/features`,
      {
        params: { query }
      }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
